// extracted by mini-css-extract-plugin
module.exports = {"supportInfo":"SupportInfo_supportInfo__ROutZ","buttonsContainer":"SupportInfo_buttonsContainer__blJYX"};